import { useState } from "react";

interface FiltersWrapperProps {
    children: React.ReactNode;
    startOpened?: boolean;
}

export default function FiltersWrapper({ children, startOpened }: FiltersWrapperProps) {
    const [open, setOpen] = useState(startOpened ?? false);
    return (
        <div className="px-4 py-2 max-w-128 mx-auto rounded-lg bg-amber-50 transition-all">
            <label onClick={() => setOpen(a => !a)} className="block cursor-pointer w-full">⚙️ Filtrer</label>
            <div className={`flex flex-col gap-2 overflow-hidden transition-all ${open ? 'h-auto p-2' : 'h-0 p-0'}`}>
                {children}
            </div>
        </div>
    );
}